import * as stylex from '@stylexjs/stylex';
import clsx from 'clsx';
import _ from 'lodash';
import { Field, useForm } from 'react-final-form';
import { getFormFieldProps, getValidationFunction } from '@/formbuilder/formbuilder.utilities';
import { SearchTitle } from '@/workbook/SearchTitle.organism';
import type { ValidatingFormComponent } from '@/formbuilder/formBuilder.types';

export interface SearchTitleIF extends ValidatingFormComponent<string> {
  component: 'SearchTitleFormComponent';
  id?: string;
  onChange: (name: string) => void;
  defaultName?: string;
  color?: string;
  onColorChange?: (color: string) => void;
  extraClassNames?: any;
  types?: string[];
}

export const SearchTitleFormComponent = (props: SearchTitleIF) => {
  const { name, validation, value, testId, onChange, extendValidation, extraClassNames, types, xstyle } = props;
  const defaultValidation = (value: string | undefined) => _.isEmpty(_.trim(value));
  const appliedValidation = getValidationFunction(defaultValidation, extendValidation, validation);
  const formState = useForm().getState();

  return (
    <div
      {...stylex.props(styles.title, xstyle)}
      className={clsx(stylex.props(styles.title, xstyle).className, extraClassNames)}
      data-testid={testId}>
      <Field<string> name={name} validate={appliedValidation}>
        {({ input, meta }) => (
          <SearchTitle
            {...getFormFieldProps(formState, input, meta, props)}
            name={value}
            setSearchName={(value: string) => {
              input.onChange(value);
              onChange(value);
            }}
            types={types}
          />
        )}
      </Field>
    </div>
  );
};

const styles = stylex.create({
  title: { flex: '1 1 auto', overflow: 'hidden', paddingInline: 5, paddingBlock: 0, marginBottom: '.9375rem' },
});
